{
  "WHITE_LABEL": "refrain",
  "APP_SCHEME": "refrainpartage",
  "APPLE_APP_ID": "6499559610",
  "CONTACT_EMAIL": "accesrefrain@lerefrain.com",
  "SUPPORTED_LANGUAGES": ["fr", "en"],
  "FEATURE_FLAGS_ENABLED": ["justOneClub", "requireActivationCodeDuringSignup", "sso", "refrainFestivalReminders"]
}